/* eslint-disable @typescript-eslint/naming-convention */
import { markDirtyTransaction } from '../repositories/TransactionRepository/dirtyTransactionHOF';
import Api, { HttpMethod } from './index';

interface IGiftWrapApiConfig {
  api: Api;
}

export interface IGiftMessageData {
  transId: number;
  cardMessageTo: string;
  cardMessageFrom: string;
  cardMessage: string;
}

export default class GiftWrapApi {
  api: Api;

  constructor({ api }: IGiftWrapApiConfig) {
    this.api = api;
  }

  async setGiftWrap(): Promise<void> {    
    const body = { trans_id: this.api.transId };
    await this.api.makeRequest(HttpMethod.POST, {
      body,
      options: {
        credentials: 'include',
      },
      url: `${this.api.baseTransactionPath}/gift_wrap`,
    });
  }

  async setGiftWrapSku(skuId: string): Promise<void> {
    const body = { trans_id: this.api.transId };
    await this.api.makeRequest(HttpMethod.POST, {
      body,
      options: {
        credentials: 'include',
      },
      url: `${this.api.baseTransactionPath}/${this.api.transId}/gift_wrap/add/${skuId}`,
    });
  }

  async removeGiftWrap():Promise<void> {
    await this.api.makeRequest(HttpMethod.DELETE, {
      body: { trans_id: this.api.transId },
      options: {
        credentials: 'include',
      },
      url: `${this.api.baseTransactionPath}/${this.api.transId}/gift_wrap/delete`,
    });
  }
  
  @markDirtyTransaction()
  async setGiftWrapMessage(info:IGiftMessageData):Promise<void> {
    const body = this.api.dataMapper.mapRequest('toCardMessage', info);

    await this.api.makeRequest(HttpMethod.POST, {
      body,
      options: {
        credentials: 'include',
      },
      url: `${this.api.baseTransactionPath}/${this.api.transId}/gift_message/add`,
    });
  }

  async removeGiftWrapMessage():Promise<void> {
    const body = { trans_id: this.api.transId };
    await this.api.makeRequest(HttpMethod.DELETE, {
      body,
      options: {
        credentials: 'include',
      },
      url: `${this.api.baseTransactionPath}/${this.api.transId}/gift_message/delete`,
    });
  }
}